import "core-js/modules/es6.regexp.replace";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";

var MoneyHelper =
/*#__PURE__*/
function () {
  function MoneyHelper() {
    _classCallCheck(this, MoneyHelper);
  }

  _createClass(MoneyHelper, [{
    key: "GetMoneyReadValue",
    value: function GetMoneyReadValue(number, round, decPlaces, decSep, thouSep) {
      if (typeof number === "string") number = number.replace("$", "");
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: round ? 0 : 2
      });
      return formatter.format((round == true ? Math.round(number) : number) || 0);
    }
  }]);

  return MoneyHelper;
}();

export default new MoneyHelper();